import { z } from 'zod';

import { Id, IsoDateTime } from '../common/primitives';

export const FileVisibilitySchema = z.enum(['PUBLIC', 'PRIVATE']);
export type FileVisibility = z.infer<typeof FileVisibilitySchema>;

export const UploadedFileSchema = z.object({
  id: Id,
  bucket: z.string(),
  key: z.string(),
  name: z.string(),
  contentType: z.string(),
  sizeBytes: z.number().int(),
  visibility: FileVisibilitySchema,
  url: z.string().nullable(),
  createdAt: IsoDateTime,
});
export type UploadedFile = z.infer<typeof UploadedFileSchema>;

export const RegisterFileRequest = z
  .object({
    name: z.string().trim().min(1).max(300),
    url: z.string().trim().url(),
    contentType: z.string().trim().min(2).max(120).optional(),
    sizeBytes: z.number().int().min(0).optional(),
    visibility: FileVisibilitySchema.optional(),
  })
  .strict();
export type RegisterFileRequest = z.infer<typeof RegisterFileRequest>;

export const ListFilesQuery = z
  .object({
    q: z.string().trim().max(200).optional(),
    sort: z.enum(['newest', 'oldest', 'name', 'size']).optional(),
    page: z.coerce.number().int().min(1).optional(),
  })
  .strict();
export type ListFilesQuery = z.infer<typeof ListFilesQuery>;
